// Point a develop console at an authentication PR deploy: `?auth_pr=1623` switches, `?auth_pr=off` resets.
// Only a PR number is accepted, so a link can never send credentials to a host of the sender's choosing.
import { AUTH_PR_GLOBAL } from './authPreviewDefine';

export { AUTH_PR_GLOBAL };
export const AUTH_PR_PARAM = 'auth_pr';
export const AUTH_PR_STORAGE_KEY = 'authPr';

// Sessions issued by one authentication deploy are unknown to another: drop them on every switch.
const SESSION_KEYS = ['jwt', 'refreshToken', 'keepAlive'];
const PR_NUMBER = /^\d{1,6}$/;

export function resolveAuthPr(search, stored) {
    const requested = new URLSearchParams(search).get(AUTH_PR_PARAM);
    if (requested === null) {
        return stored;
    }
    if (requested === '' || requested === 'off') {
        return null;
    }
    return PR_NUMBER.test(requested) ? requested : stored;
}

function withoutParam(location) {
    const params = new URLSearchParams(location.search);
    params.delete(AUTH_PR_PARAM);
    const search = params.toString();
    return `${location.pathname}${search ? `?${search}` : ''}${location.hash}`;
}

export function applyAuthPreview(win, storage) {
    const stored = storage.getItem(AUTH_PR_STORAGE_KEY);
    const authPr = resolveAuthPr(win.location.search, stored);
    if (authPr !== stored) {
        SESSION_KEYS.forEach((key) => storage.removeItem(key));
        if (authPr) {
            storage.setItem(AUTH_PR_STORAGE_KEY, authPr);
        } else {
            storage.removeItem(AUTH_PR_STORAGE_KEY);
        }
    }
    if (new URLSearchParams(win.location.search).has(AUTH_PR_PARAM)) {
        win.history.replaceState(win.history.state, '', withoutParam(win.location));
    }
    return authPr;
}

export function currentAuthPr(win = window) {
    return win[AUTH_PR_GLOBAL] || null;
}
